import { Drawer } from '@mui/material';

import { GDMDrawerComponent } from './GDMDrawer.type';

/* TODO: Implement component using GDM default design */
const GDMDrawer: GDMDrawerComponent = props => <Drawer {...props} />;

export default GDMDrawer;
